module.exports = __webpack_public_path__ + "assets/img/317f8d84ac0584964d187f0d92905226.svg";